import React from 'react';
import { Helmet } from 'react-helmet-async';
import { seo } from '../config/seo';

const getBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location.origin) return window.location.origin;
  return process.env.REACT_APP_SITE_URL || '';
};

/**
 * Renders SEO meta tags (title, description, Open Graph, Twitter Card).
 * @param {string} title - Page title
 * @param {string} [description] - Meta description (optional)
 * @param {string} [image] - Absolute URL for og:image (optional, falls back to seo.defaults.image)
 * @param {boolean} [noIndex] - If true, adds robots noindex,nofollow
 * @param {string} [path] - Path for canonical/og:url (e.g. '/events'). If omitted, uses window.location.pathname.
 */
const SeoHelmet = ({ title, description, image, noIndex, path }) => {
  const baseUrl = getBaseUrl();
  const url = path !== undefined ? `${baseUrl}${path}` : (typeof window !== 'undefined' ? `${baseUrl}${window.location.pathname}` : baseUrl);
  const desc = description || seo.defaults.description;
  const img = image || seo.defaults.image;
  const fullImage = img && !img.startsWith('http') && baseUrl ? `${baseUrl}${img}` : img;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      {fullImage && <meta property="og:image" content={fullImage} />}
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      {fullImage && <meta name="twitter:image" content={fullImage} />}
    </Helmet>
  );
};

export default SeoHelmet;
